import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChatLogService {

  constructor(private http: HttpClient) { }

  async getLogs(filters: any, queryParams: any) {
    let params = new HttpParams();
    if (queryParams.page) {
      params = params.set('page', queryParams.page);
    }
    if (queryParams.limit) {
      params = params.set('limit', queryParams.limit);
    }
    if (queryParams.sortField) {
      if (queryParams.sortField == 'name') {
        queryParams.sortField = 'first_name';
      }
      params = params.set('sortField', queryParams.sortField);
    }
    if (queryParams.sortOrder) {
      params = params.set('sortOrder', queryParams.sortOrder);
    }
    return this.http.post<any>(`${environment.baseUrl}chatbot/get-chatbot-logs`, { body: filters}, { params });
  }

  async updateChatBotShowSetting(filters: any) {
    return await this.http.post<any>(`${environment.baseUrl}chatbot/update-chatbot-show-setting`, filters).toPromise();
  }

  async getChatBotShowSetting(propertyId: string) {
    return this.http.get<any>(`${environment.baseUrl}chatbot/get-chatbot-show-setting`, {
      params: { propertyId }
    }).toPromise();
  }

  getLogsByPhone(phoneNumber: string) {
    return this.http.post<{ history: { type: string; content: string; time: Date }[] }>(
      `${environment.baseUrl}chatbot/get-logs-by-phone`,
      { phone_number: phoneNumber }
    );
  }
}
